export const Types = {
    campaign: {
        types: {
            national: "Nationale",
            national_Uid: "359f61346a5326979f14e9ab4590efb9"
        },
        milestones: {
            start_date: "Début",
            end_date: "Fin",
            display_date: "DisplayDate",
            updated_date: "updated_date",
        },
        attrs: {
            show_paf: "show_paf",
            is_paf: "is_paf",
            code: "code",
            updated_date: "updated_date",
        }
    },
    document: {
        types: {
            tract: "Tract",
            tract_Uid: "c630933c46cd92eeaa7d15bb2a557f00"
        }
    },
    product: {
        datasets: {
            Ean: "ean",
            Brand: "brand",
            Thematic: "thematic",
            Codelec: "codelec",
            Meca: "meca",
            GreenTaxFurniture: "greenTaxFurniture",
            GreenTaxElectronic: "greenTaxElectronic",
            PlusProduct: "plusProduct",
            Origine: "origine",
            OriginePays: "originePays",
            Mention: "mention",
            CodeInternet: "codeInternet",
            RefArticle: "refArticle",
            AcheterEnLigne: "acheterEnLigne",
            LienExternUrl: "lienExternUrl",
            LienExternLabel: "lienExternLabel",
            VignettePromoLigne1: "vignettePromoLigne1",
            VignettePromoLigne2: "vignettePromoLigne2",
            IsDrive: "isDrive",
            LegalNotices: "legalNotices",
            CodeService: "codeService",
            DisplaySupplierRef: "displaySupplierRef",
            SupplierRef: "supplierRef",
            France1: "france1",
            France2: "france2",
            France3: "france3",
            EcatOnly: "ecatOnly",
            OperationType: "operationType",
            ParentCategories: "parentCategories",
            IsCC: "isCC",
            Description: "description",
            MandatStartDate: "mandatStartDate",
            MandatEndDate: "mandatEndDate",
            DiscountLabel: "discountLabel",
            Price: "price",
            DiscountAmount: "discountAmount",
            DiscountUnit: "discountUnit",
            DiscountPriceQty: "discountPriceQty",
            PriceWithoutDiscount: "priceWithoutDiscount",
            OffertX: "offertX",
            OffertY: "offertY",
            DiscountedPriceLot: "discountedPriceLot",
            DiscountedPriceSecondProduct: "discountedPriceSecondProduct",
            Conditioning: "conditioning",
            MEA: "MEA",
            IsPartner: "isPartner",
            Vitesses: "vitesses",
            Trade: "trade",
        }
    }
};
export const CampaignTypes = [
    {
        brand_uids: [],
        inactive: false,
        name: Types.campaign.types.national,
        uid: Types.campaign.types.national_Uid
    }
];
/**
 * return the campaign type model by the name
 * @param name
 * @constructor
 */
export function GetCampaignTypeByName(name) {
    const index = CampaignTypes.findIndex(e => e.name === name);
    if (index >= 0) {
        return CampaignTypes[index];
    }
    else {
        return undefined;
    }
}
/**
 * return the campaign type model by the uid
 * @param uid
 * @constructor
 */
export function GetCampaignTypeByUid(uid) {
    const index = CampaignTypes.findIndex(e => e.uid === uid);
    if (index >= 0) {
        return CampaignTypes[index];
    }
    else {
        return undefined;
    }
}
export function getColor(title = "") {
    if (!title)
        return "#FFFFFF";
    let nb = (title.charCodeAt(0) + title.charCodeAt(title.length - 1) - 100) / 80;
    nb = nb > 1 ? 1 : nb;
    return "hsl(" + 360 * nb + ',' + (25 + 70 * nb) + '%,' + (85 + 10 * nb) + '%)';
}
export const MAX_ZOOM_VALUE = 20;
export const MIN_ZOOM_VALUE = 10;
export const ZOOM_STEP = 2;
